import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useRoutesStore } from '@/store/modules/routes';
const HISTORY_KEY = 'vab_search_history';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const isMac = /macintosh|mac os x/i.test(navigator.userAgent);
    const MOD_KEY = isMac ? 'metaKey' : 'ctrlKey';
    const show = ref(false);
    const search = ref('');
    const activeIndex = ref(0);
    const inputRef = ref(null);
    const routesStore = useRoutesStore();
    const {
      getRoutes
    } = storeToRefs(routesStore);
    const router = useRouter();
    // 递归平铺所有菜单项
    function flattenMenus(routes, basePath = '', parentIcon = undefined) {
      let result = [];
      routes.forEach(route => {
        if (route.meta && route.meta.hidden) return;
        const fullPath = route.path.startsWith('/') ? route.path : `${basePath}/${route.path}`;
        const icon = route.meta && route.meta.icon ? route.meta.icon : parentIcon;
        if (route.meta && route.meta.title) {
          result.push({
            title: route.meta.title,
            path: fullPath,
            icon,
            ...route.meta
          });
        }
        if (route.children && route.children.length > 0) {
          result = result.concat(flattenMenus(route.children, fullPath, icon));
        }
      });
      return result;
    }
    const menuList = computed(() => flattenMenus(getRoutes.value));
    // 搜索历史（localStorage）
    const searchHistory = ref([]);
    function loadHistory() {
      const raw = localStorage.getItem(HISTORY_KEY);
      searchHistory.value = raw ? JSON.parse(raw) : [];
    }
    function saveHistory(keyword) {
      if (!keyword) return;
      let arr = searchHistory.value.filter(item => item !== keyword);
      arr.unshift(keyword);
      if (arr.length > 8) arr = arr.slice(0, 8);
      searchHistory.value = arr;
      localStorage.setItem(HISTORY_KEY, JSON.stringify(arr));
    }
    function removeHistory(keyword) {
      searchHistory.value = searchHistory.value.filter(item => item !== keyword);
      localStorage.setItem(HISTORY_KEY, JSON.stringify(searchHistory.value));
    }
    function clearHistory() {
      searchHistory.value = [];
      localStorage.removeItem(HISTORY_KEY);
    }
    // 简单模糊搜索（可扩展为拼音/多字段）
    const filteredMenus = computed(() => {
      if (!search.value) return menuList.value;
      return menuList.value.filter(item => item.title.toLowerCase().includes(search.value.toLowerCase()) || item.path && item.path.toLowerCase().includes(search.value.toLowerCase()));
    });
    function openSearch() {
      show.value = true;
      search.value = '';
      activeIndex.value = 0;
      loadHistory();
      nextTick(() => {
        inputRef.value?.focus();
      });
    }
    function closeSearch() {
      show.value = false;
    }
    function selectMenu(index) {
      const item = filteredMenus.value[index];
      if (item && item.path) {
        saveHistory(search.value);
        closeSearch();
        // 检查是否为外链
        if (item.target === '_blank' || item.path.startsWith('http://') || item.path.startsWith('https://') || item.path.startsWith('//')) {
          // 外链使用window.open
          window.open(item.path, '_blank');
        } else {
          // 内部路由使用router.push
          router.push(item.path);
        }
      }
    }
    function selectHistory(keyword) {
      search.value = keyword;
      activeIndex.value = 0;
      nextTick(() => {
        inputRef.value?.focus();
      });
    }
    function onKeydown(e) {
      if (show.value) {
        if (e.key === 'Escape') {
          closeSearch();
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          activeIndex.value = (activeIndex.value + 1) % filteredMenus.value.length;
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          activeIndex.value = (activeIndex.value - 1 + filteredMenus.value.length) % filteredMenus.value.length;
        } else if (e.key === 'Enter') {
          selectMenu(activeIndex.value);
        }
      } else {
        if (e[MOD_KEY] && e.key.toLowerCase() === 'k') {
          e.preventDefault();
          openSearch();
        }
      }
    }
    onMounted(() => {
      window.addEventListener('keydown', onKeydown);
    });
    onUnmounted(() => {
      window.removeEventListener('keydown', onKeydown);
    });
    function onItemClick(idx) {
      selectMenu(idx);
    }
    function onInputKeydown(e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === 'Escape') {
        // 交由全局keydown处理
        e.preventDefault();
      }
    }
    const __returned__ = {
      isMac,
      MOD_KEY,
      show,
      search,
      activeIndex,
      inputRef,
      routesStore,
      getRoutes,
      router,
      flattenMenus,
      menuList,
      HISTORY_KEY,
      searchHistory,
      loadHistory,
      saveHistory,
      removeHistory,
      clearHistory,
      filteredMenus,
      openSearch,
      closeSearch,
      selectMenu,
      selectHistory,
      onKeydown,
      onItemClick,
      onInputKeydown
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});